import * as classNames from 'classnames';
import { ContentEditable } from 'components/content';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./../LeadQuestions.css');

// Props
interface IQuestionOptionTextProps {
  className?: string;
  onChange: (html: string, text: string) => void;
  placeholder?: string;
  value: string;
}

// Component
@observer
export class QuestionOptionText extends React.Component<
  IQuestionOptionTextProps,
  {}
> {
  static get defaultProps(): IQuestionOptionTextProps {
    return {
      className: null,
      onChange: null,
      value: null,
    };
  }

  constructor(props: IQuestionOptionTextProps) {
    super(props);
  }

  public render() {
    return (
      <ContentEditable
        classNameForField={classNames(s.optionText, this.props.className)}
        onChange={this.props.onChange}
        placeholder={
          typeof this.props.placeholder !== 'undefined'
            ? this.props.placeholder
            : undefined
        }
        html={this.props.value}
        contentEditable={true}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Questions/Options/QuestionOptionText.tsx